<script>
    import { ValueService } from '../../services/ValueService.js';

    /**
     * @type {{
     *     tag?: string,
     *     color?: string,
     *     label?: string,
     *     mono?: boolean,
     * }}
     */
    let { tag = 'span', color = '', label = '', mono = false } = $props();

    /** @type {{ [key: string]: string }} */
    const allowedTags = {
        span: 'span',
        div: 'div',
    };
    const thisTag = $derived(allowedTags[ValueService.toStringSingleLine(tag)] ?? 'span');

    // -
    const thisColor = $derived(
        '#' +
            (ValueService.toStringSingleLine(color) + '000000')
                .toLocaleLowerCase()
                .replace(/[^0-9a-f]/g, '')
                .substring(0, 6)
    );
    const thisLabel = $derived(ValueService.toStringSingleLine(label));
    const thisMono = $derived(ValueService.toBool(mono));
</script>

<svelte:element this={thisTag} class="flex items-center gap-2">
    <span class="block h-3 w-3 rounded-full" style={`background-color: ${thisColor}`}></span>
    {#if thisLabel}
        <span class="text-sm {thisMono ? 'font-mono' : ''}">
            {thisLabel}
        </span>
    {/if}
</svelte:element>
